import { z } from 'zod';
/** Segni giocabili su una partita fissa. */
export const pickValues = ['HOME', 'DRAW', 'AWAY', 'HOME_DRAW', 'DRAW_AWAY', 'HOME_AWAY'];
export const isDoublePick = (pick) => pick === 'HOME_DRAW' || pick === 'DRAW_AWAY' || pick === 'HOME_AWAY';
/** Etichette leggibili (usate da UI e annunci screen reader). */
export const PICK_LABELS = {
    HOME: '1 — vittoria squadra di casa',
    DRAW: 'X — pareggio',
    AWAY: '2 — vittoria squadra ospite',
    HOME_DRAW: 'doppia 1X — casa o pareggio',
    DRAW_AWAY: 'doppia X2 — pareggio o ospite',
    HOME_AWAY: 'doppia 12 — casa o ospite',
};
/**
 * Schedina inviata dall'utente. La validazione di struttura sta qui;
 * i vincoli di regolamento (numero partite, doppie ammesse, OVER obbligatorio)
 * vengono verificati dal server contro la RulesetConfig della giornata.
 */
export const submitPredictionSchema = z.object({
    /** Pronostici fissi: partita + segno. */
    items: z
        .array(z.object({
        matchId: z.string().min(1),
        pick: z.enum(pickValues),
    }))
        .min(1)
        .max(20),
    /** Risultato esatto sulla "quinta partita" (se il regolamento lo prevede). */
    exact: z
        .object({
        matchId: z.string().min(1),
        home: z.number().int().min(0).max(20),
        away: z.number().int().min(0).max(20),
    })
        .optional(),
    /** Partita scelta per l'OVER. */
    overMatchId: z.string().min(1).optional(),
});
//# sourceMappingURL=prediction.js.map